import React from 'react';
import '../Section10/component.css';

const Section10 = () => {
  return (
    <div className="svc-intro">

      <div className="svc-intro-inner">
        <span className="svc-label">Development</span>
        <h2 className="svc-intro-title">Your Expert Partner in Website Development</h2>
        <p className="svc-intro-body">
          At Hypertonic It Solutions, we understand the pivotal role that a well-designed and functional website plays in establishing a strong online presence for your business. With the ever-growing importance of digital platforms, having a professionally crafted website is no longer a luxury but a necessity for businesses of all sizes and industries.
        </p>
      </div>
    </div>
  );
};

export default Section10;
